module.exports = __webpack_public_path__ + "fonts/Helios-Bold.de5dd7b0.otf";